import styled from "@emotion/styled";
import { createFocusRingStyles } from "../../../util/createFocusRingStyles";
import { withFocusToggleClassName } from "../../../util/withFocusClassName";
import { bannerTheme } from "./bannerTheme";
const getColor = _ref => {
  let {
    type,
    themeMode
  } = _ref;
  return `var(--sds--banner--text-color--${type},${bannerTheme.fontColor[type](themeMode)})`;
};
const getBackgroundColor = _ref2 => {
  let {
    type,
    themeMode
  } = _ref2;
  return `var(--sds--banner--background-color--${type},${bannerTheme.backgroundColor[type](themeMode)})`;
};
export const BannerStyled = withFocusToggleClassName(styled("div")`
    min-height: 48px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;

    color: ${getColor};
    background-color: ${getBackgroundColor};

    font-weight: 500;
    font-size: 14px;

    ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return createFocusRingStyles({
    theme: themeMode,
    componentRadius: "0",
    gap: 1,
    componentBorderWidth: 1
  });
}};
`);
BannerStyled.displayName = "BannerStyled";
//# sourceMappingURL=BannerStyled.js.map